import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Material-UI imports
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

// Third-party library imports
import { Flex } from "reflexbox";

// Local component imports
import CopyItem from "../components/common/CopyItem";
import PageHeader from "../components/gamePlayComponents/PageHeader";
import ResetButton from "../components/gameSetupAndLobby/DeleteMyDataButtons";
import { ScoreSummaryCard } from "../components/leaderboard/ScoreSummary";

// Utility/helper imports
import { ANALAGOUSCOLOR1 } from "../components/helpers/ThemeSettings";
import { courseFriendlyName, coursesKeys } from "../components/courseContent/courseObjects";
import * as routes from "../components/helpers/routes";
import { usePlatformInsets } from "../components/helpers/usePlatformInsets";
import BottomBar from "../components/common/BottomBar";

const DevTestScreen = () => {
  let navigate = useNavigate();
  const uid = useSelector((state) => state.user?.uid);
  const platformState = useSelector((state) => state.platform);
  const insets = usePlatformInsets();
  const [testURL, setTestURL] = useState('');


  const helpfulURLAdditions = ['/', '/q/', '/answer', routes.LEADERBOARD, routes.MAP, routes.END, routes.SUMMARY, routes.PAY];

  const ChipComponent = (val, key) => <Chip key={key} label={val} style={{margin: '4px', border: `1px solid ${ANALAGOUSCOLOR1}`}}
                                       onClick={() => setTestURL(`${testURL}${val}`)}/>;

  return (
    <>
      <PageHeader goBack title={'Test Tools'}/>
      <ScoreSummaryCard title={'Platform insets (debug)'}>
        <Typography variant="body2">redux platform: {String(platformState.platform)}</Typography>
        <Typography variant="body2">redux bottomInset: {platformState.bottomInset}</Typography>
        <Typography variant="body2">isNative: {String(insets.isNative)}</Typography>
        <Typography variant="body2">measuredBottomInset: {insets.measuredBottomInset}</Typography>
        <Typography variant="body2">applied bottomInset: {insets.bottomInset}</Typography>
        <Typography variant="body2">ReactNativeWebView: {String(!!window.ReactNativeWebView)}</Typography>
      </ScoreSummaryCard>
      <ScoreSummaryCard title={'User ID (UID)'}>
        <Flex>
          <Typography style={{color: ANALAGOUSCOLOR1, marginRight: '12px'}}> {uid}</Typography>
          <CopyItem thingToCopy={uid} />
        </Flex>
      </ScoreSummaryCard>

      <ScoreSummaryCard title={'Delete Data'}>
        <ResetButton/>
      </ScoreSummaryCard>

      <ScoreSummaryCard title={'Course content review'}>
        <Typography variant="body2" style={{ marginBottom: 12 }}>
          Open a full scrollable dump of every question and answer for editing.
        </Typography>
        <Flex style={{ flexWrap: 'wrap', gap: 8 }}>
          {coursesKeys.map((courseKey) => (
            <Button
              key={courseKey}
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => navigate(routes.ToCourseContentReview(courseKey))}
            >
              {courseFriendlyName(courseKey) || courseKey}
            </Button>
          ))}
        </Flex>
      </ScoreSummaryCard>
      {/*<Typography> Test course </Typography>*/}
      {/*<Typography> Test share button </Typography>*/}
      <ScoreSummaryCard title={'Jump to route'}>
        <Flex style={{ width: '100%'}}>
          <TextField label="Desired URL" value={testURL}
                     style={{width: '100%'}}
                     onChange={(e) => setTestURL(e.target.value)}/>
        </Flex>
        <Button variant={'contained'} color={'primary'}
                disabled={!testURL}
                onClick={() => navigate(testURL)}
                size={'small'} style={{margin: '16px 0'}}>Go!</Button>

        <Typography> Course </Typography>
        <Flex style={{flexWrap: 'wrap'}}>
          {coursesKeys.map(el => ChipComponent(`/course/${el}`, el))}
        </Flex>
        <Typography> Helpful URLs </Typography>
        <Flex style={{flexWrap: 'wrap'}}>
          {helpfulURLAdditions.map(el => ChipComponent(el, el))}
        </Flex>
      </ScoreSummaryCard>
      <BottomBar>
        <Button variant="contained" color="primary" style={{ width: '100%' }}>
          Inset test bar
        </Button>
      </BottomBar>
    </>
  )
};

export default DevTestScreen;